import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
export function UrgencySection() {
  return <section className="w-full bg-pink-soft border-t-2 border-b-2 border-pink-light py-10 md:py-14 px-4" data-id="element-436">
      <div className="max-w-[680px] mx-auto text-center" data-id="element-437">
        <AlertTriangleIcon className="w-12 h-12 text-pink-dark mx-auto mb-6" data-id="element-438" />

        <h2 className="font-heading font-bold text-xl md:text-2xl text-dark-gray mb-4" data-id="element-439">
          Los bonos son parte de este lanzamiento
        </h2>

        <div className="font-body text-dark-gray text-base md:text-lg leading-relaxed space-y-3" data-id="element-440">
          <p data-id="element-441">No sé hasta cuándo voy a incluir los 5 bonos con la compra.</p>
          <p data-id="element-442">Cuando cierre esta oferta, la guía seguirá disponible.</p>
          <p className="font-bold text-pink-dark" data-id="element-443">Los bonos, no.</p>
        </div>
      </div>
    </section>;
}